import { FC } from 'react';
import { CheckboxSingle } from '../CheckboxSingle';
import { PropertyTypesGrid } from '../styles';
import { CSSProperties } from 'styled-components';
import { useTranslations } from 'next-intl';

interface CheckboxSectionProps {
  items: string[];
  handleSetSelected: (type: string, b: string | string[]) => void;
  selectedArr: string[];
  type: string;
  style?: CSSProperties;
}

export const CheckboxSection: FC<CheckboxSectionProps> = ({
  items,
  handleSetSelected,
  selectedArr,
  type,
  style = {},
}) => {
  const t = useTranslations();

  return (
    <PropertyTypesGrid style={style}>
      {items.map((p) => {
        return (
          <CheckboxSingle
            key={p}
            name={t(p as any)}
            value={p}
            handleSetSelected={handleSetSelected}
            selectedArr={selectedArr}
            type={type}
          />
        );
      })}
    </PropertyTypesGrid>
  );
};

interface CheckboxSectionWithArrayOfObjectProps {
  items: { title: string; value: string | string[] }[];
  handleSetSelected: (type: string, b: string | string[]) => void;
  selectedArr?: string[];
  type: string;
  style?: CSSProperties;
}

export const CheckboxSectionWithArrayOfObject: FC<CheckboxSectionWithArrayOfObjectProps> = ({
  items,
  handleSetSelected,
  selectedArr,
  type,
  style,
}) => {
  const t = useTranslations()
  // for life_styles, if selectedArr is empty, then the selectedArr needs to have all the values of items
  if (selectedArr?.length === 0 && type === 'life_styles') {
    selectedArr = items.map((item) => item.value) as string[];
  }
  return (
    <PropertyTypesGrid style={style}>
      {items.map((p, indx) => {
        return (
          <CheckboxSingle
            key={`pt-${indx}`}
            name={t(p.title as any)}
            value={p.value}
            handleSetSelected={handleSetSelected}
            selectedArr={selectedArr}
            type={type}
          />
        );
      })}
    </PropertyTypesGrid>
  );
};
